import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IScriptGroupKeyPropertyEditable {
  scriptGroupKey(): IPropertyEditable<string>;
}

export function instanceOfIScriptGroupKeyPropertyEditable(instance: any): instance is IScriptGroupKeyPropertyEditable {
  return instance
      && instance.scriptGroupKey
      && instanceOfIPropertyEditable<string>(instance.scriptGroupKey());
}
